import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store/models';
import store from '../../../../store';
import { useFeatureFlagRedux } from '../../../../hooks';
import { CHAT_GENERAL_SWITCH } from '../../../../modules/chat/constants';

export const useShouldShowClientNavBar = (): {
  shouldShowClientNav: boolean;
  loading: boolean;
  isChatGeneralSwitchEnabled: boolean;
} => {
  const shouldShowClientNav = useSelector<RootState, boolean>(
    store.select.clientNavBar.shouldShow,
  );
  const {
    loading: isLoading,
    enabled: isChatGeneralSwitchEnabled,
  } = useFeatureFlagRedux(CHAT_GENERAL_SWITCH);

  return {
    shouldShowClientNav,
    loading: isLoading,
    isChatGeneralSwitchEnabled,
  };
};
